const lpodTOC = {
    nachalo: 'Начало',
    priugotovlenie: 'Приуготовление',
};
export default lpodTOC;
